<div>
  <div class="button-center" *ngFor="let loggingInCard of loggingInCards">
    <span *ngIf="loggingInCard.headText">{{ loggingInCard.headText }}</span>
    <p *ngIf="loggingInCard.shortBody" class="mb-4">{{ loggingInCard.shortBody }}</p>
    <a class="ba-btn ba-btn-thin sml" href="{{ loggingInCard.buttonUrl }}" rel="button" role="button" target="_blank"> {{ loggingInCard.buttonText }} </a><br />&nbsp;
  </div>
</div>
